import { getAnalytics, logEvent } from "firebase/analytics";
import { app } from "../firebase/config";

const analytics = getAnalytics(app);

export const trackButtonClick = (buttonName, additionalParams = {}) => {
  logEvent(analytics, "button_click", {
    button_name: buttonName,
    ...additionalParams,
  });
};

export const trackPageView = (pageName, additionalParams = {}) => {
  logEvent(analytics, "page_view", {
    page_name: pageName,
    ...additionalParams,
  });
};

export const trackFeatureUsage = (featureName, additionalParams = {}) => {
  logEvent(analytics, "feature_use", {
    feature_name: featureName,
    ...additionalParams,
  });
};

export const trackVideoView = (videoName, additionalParams = {}) => {
  logEvent(analytics, "video_view", {
    video_name: videoName,
    ...additionalParams,
  });
};

export const trackContactClick = (contactType, additionalParams = {}) => {
  logEvent(analytics, "contact_click", {
    contact_type: contactType,
    ...additionalParams,
  });
};
